document.addEventListener("DOMContentLoaded", function () {
  $('.page-loader').addClass('hide');

  window.addEventListener('load', function () {
    document.querySelectorAll('.card_bottom_hover').forEach(function (el) {
      const cbh_item = el.querySelector('.cbh_item');
      if (cbh_item && cbh_item.offsetWidth >= el.offsetWidth) {
        cbh_item.classList.add('scrollTextAni');
      }
    });
  });

  // Initialize color/design swatch hover effect
  function initializeSwatchHover() {
    document.querySelectorAll('.color-swatch[data-variant-id][data-variant-image]').forEach(function(swatch) {
      const variantId = swatch.getAttribute('data-variant-id');
      const variantImage = swatch.getAttribute('data-variant-image');
      const productItem = swatch.closest('.new-grid-item');
      
      if (!productItem || !variantId || !variantImage) return;

      const colorImageDiv = productItem.querySelector('.grid-product__color-image--' + variantId);
      if (!colorImageDiv) return;

      // Set background image if not already set
      if (!colorImageDiv.style.backgroundImage) {
        colorImageDiv.style.backgroundImage = 'url(' + variantImage + ')';
      }

      // Mouseenter - show variant image
      swatch.addEventListener('mouseenter', function() {
        // Remove active class from all color images in this product
        productItem.querySelectorAll('.grid-product__color-image').forEach(function(img) {
          img.classList.remove('is-active');
        });
        // Add active class to this variant's image
        colorImageDiv.classList.add('is-active');
      });

      // Mouseleave - hide variant image
      swatch.addEventListener('mouseleave', function() {
        colorImageDiv.classList.remove('is-active');
      });
    });
  }

  // Initialize on page load
  initializeSwatchHover();

  // Make function available globally for load more button
  window.initializeSwatchHover = initializeSwatchHover;
});
